module.exports = __webpack_public_path__ + "static/media/client14.d5821d04.webp";